var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-corporation',{attrs:{"hasFinalTaxType":_vm.hasFinalTaxType}},[_c('div',{attrs:{"slot":"tax"},slot:"tax"},[_vm._v("โดยปีนี้คุณจะเสียภาษีประมาณ "+_vm._s(_vm.tax)+" บาท")])])}
var staticRenderFns = []

export { render, staticRenderFns }